import { render, staticRenderFns } from "./CartOrder.vue?vue&type=template&id=565bc101&scoped=true"
import script from "./CartOrder.vue?vue&type=script&lang=js"
export * from "./CartOrder.vue?vue&type=script&lang=js"
import style0 from "./CartOrder.vue?vue&type=style&index=0&id=565bc101&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565bc101",
  null
  
)

export default component.exports